// extracted by mini-css-extract-plugin
export default {"tabBar":"Tabs_tabBar__j09Ls","primary":"Tabs_primary__VO-0S","tab":"Tabs_tab__51PAi","active":"Tabs_active__ICaQI","secondary":"Tabs_secondary__5P9Em"};